'use client';
import React from 'react';
import './dpu-alumni.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { faCirclePlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Common_title from '../../common_components/common-title/Common_title';

const Dpu_alumni = () => {

  return (
    <>
      <section className="Dpu_alumni_sec">
        <div className="container">
          <Common_title
            className="text-center"
            title="DPU Reviews "
            subtitle="by candidate who complited online mba program"
          />

          <section className="Our_reels">
            <div className="container">
              <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                spaceBetween={20}
                slidesPerView={2.2}
                breakpoints={{
                  576: { slidesPerView: 3 },
                  768: { slidesPerView: 4 },
                  1024: { slidesPerView: 4 },
                }}
                className="reels_slider"
              >
            
                <SwiperSlide>
                  <iframe
                    className="reel_card"
                    src="https://www.youtube.com/embed/W1YheUFcOXM"
                    title="Build Your Tech Career with Online MCA"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                    loading="lazy"
                  >
                    {' '}
                  </iframe>
                </SwiperSlide>

                <SwiperSlide>
                  <iframe
                    className="reel_card"
                    src="https://www.youtube.com/embed/hvZpX4IP8zo"
                    title="Refer and Earn | Profcyma"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                    loading="lazy"
                  ></iframe>
                </SwiperSlide>

                <SwiperSlide>
                  <iframe
                    className="reel_card"
                    src="https://www.youtube.com/embed/NR_BEG8lais"
                    title="Upgrade Your Career with an Online MBA"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                    loading="lazy"
                  ></iframe>
                </SwiperSlide>

                <SwiperSlide>
                  <iframe
                    className="reel_card"
                    src="https://www.youtube.com/embed/n_yZU_9G7e0"
                    title="From Doubt to Degree — My Online MBA with Profcyma &amp; Dr. DY Patil University"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                    loading="lazy"
                  ></iframe>
                </SwiperSlide>
              </Swiper>
            </div>
          </section>
        
        </div>
      </section>
    </>
  );
};

export default Dpu_alumni;
